import { ReactElement } from 'react'

import { Breadcrumb } from 'antd'
import { truncate } from 'lodash'
import { Link } from 'react-router-dom'

import { Flex } from 'components/core'
import { elementToString } from 'helpers/utilities'
import { Breadcrumb as BreadcrumbType } from 'types'

import * as styles from './styles.scss'

interface Props {
    items: BreadcrumbType[]
}

const AppBreadcrumb = ({ items }: Props): ReactElement => {
    const finalItems = items.map(
        (
            { name, url, icon, iconPlacement = 'before' }: BreadcrumbType,
            index: number
        ) => {
            const isFirst = index === 0
            const isLast = index === items.length - 1
            // only truncate middle items,
            // let CSS ellipsis take care of the last based on available space
            const text =
                !isFirst && !isLast
                    ? truncate(elementToString(name), {
                          length: 25,
                      })
                    : name

            return {
                key: name as string,
                title: (
                    <Flex gap={4}>
                        {iconPlacement === 'before' && icon}
                        <span title={elementToString(name)}>
                            {url ? (
                                <Link to={url} style={{ background: 'none' }}>
                                    {text}
                                </Link>
                            ) : (
                                text
                            )}
                        </span>
                        {iconPlacement === 'after' && icon}
                    </Flex>
                ),
            }
        }
    )

    return (
        <Breadcrumb className={styles['ant-breadcrumb']} items={finalItems} />
    )
}

export default AppBreadcrumb
